module.exports = __webpack_public_path__ + "img/add.7e36ba47.svg";